import { AudioMetadata } from '../metadata/audio-metadata.model';
import { environment } from '../../../environments/environment';

export class StoryAudioLink {
  public id: string;
  public url: string;
  public meta: AudioMetadata;

  constructor(data: any = {}) {
    this.id = data?.id ?? '';
    this.meta = data?.meta ?? {};
    this.url = `${environment.apiUrl}/api/media/${this.id}`;
  }

  public static createFromApi(data: any = {}): StoryAudioLink {
    const meta = AudioMetadata.createFromApi(data?.meta ?? {});
    return new StoryAudioLink({
      ...data,
      meta,
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      meta: this.meta.processForApi(),
    }
  }

}
